import { Box, Button, Heading, Input, LightMode, Stack, Text, useBoolean } from '@chakra-ui/react'
import { useState } from 'react'
import { useRouter } from 'next/router'
import Image from 'next/image'
import { wait } from '../../../../shared/helpers'

export const HeroUserFlows = ({ subheading, opts = {} }) => {
    const [inputVal, setInputVal] = useState()
    const router = useRouter()
    const [isLoading, setIsLoading] = useBoolean(false)
    return (
        <Box as="section" color={opts?.color || "initial"}>
            <Box
                maxW={{ base: 'xl', md: '5xl' }}
                mx="auto"
                px={{ base: '6', md: '8' }}
            >
                <Stack spacing={{ base: 12, md: 20 }}>
                    <Stack mx="auto" align="center" spacing={{ base: '4', md: '6' }} maxW={{ md: 'xl', lg: '3xl' }} textAlign="center">
                        <Heading size={{ base: 'md', md: 'xl' }} color="fg.default" fontWeight="extrabold">User Flow & Customer Journey Tool</Heading>
                        <Text fontSize={{ base: 'lg', md: 'xl' }} maxW="lg" color="fg.default">
                            Create sophisticated user flows and customer journeys, from potential landing page pathways to existing key conversion journeys.
                        </Text>
                    </Stack>
                    <Stack direction={{ base: 'column', md: 'row' }} spacing={4.5} justify="center">
                        <LightMode>
                            <Input
                                placeholder="Enter your email address..."
                                type="email"
                                isRequired
                                size={{ base: 'xl', md: '2xl' }}
                                px={4.5}
                                maxW={{ lg: 'xl' }}
                                fontWeight="medium"
                                fontSize="lg !important"
                                onChange={(e) => setInputVal(e.target.value)}
                                color="fg.default"
                            />
                        </LightMode>
                        <Button
                            size={{ base: 'xl', md: '2xl' }}
                            bgColor="blue.200"
                            _hover={{ bgColor: "blue.100" }}
                            onClick={async () => {
                                setIsLoading.toggle()
                                try {
                                    await wait(1000)
                                    if (!inputVal) return
                                    router.push(`/app/signup?e=${inputVal}`)
                                } catch (e) {
                                    console.error(e)
                                } finally {
                                    await wait(1000)
                                    setIsLoading.toggle()
                                }
                            }}
                            isLoading={isLoading}
                        >
                            Get started free
                        </Button>
                    </Stack>
                    <LightMode>
                        <Box bgColor="rarchy-bg-white" borderRadius="md" boxShadow="2xl">
                            <Image
                                style={{ borderRadius: "5px" }}
                                width="960"
                                height="590"
                                alt="Screenshot of User Flows"
                                src="/images/heroes/user-flow.webp"
                                rel="preload"
                                priority="true"
                                fetchpriority="high"
                            />
                        </Box>
                    </LightMode>
                </Stack>
            </Box>
        </Box>
    )
}